import { render, staticRenderFns } from "./EditServiceSideBarTabsInfo.vue?vue&type=template&id=2667aeb3&"
import script from "./EditServiceSideBarTabsInfo.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarTabsInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceSideBarTabsInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports